import { render, staticRenderFns } from "./BaseAsideMainNav.vue?vue&type=template&id=03be86a5&scoped=true&"
import script from "./BaseAsideMainNav.vue?vue&type=script&lang=js&"
export * from "./BaseAsideMainNav.vue?vue&type=script&lang=js&"
import style0 from "./BaseAsideMainNav.vue?vue&type=style&index=0&id=03be86a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03be86a5",
  null
  
)

export default component.exports